module.exports = __webpack_public_path__ + "static/media/ly.27ae749c.svg";